'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n\n    margin: 10px 0;\n'], ['\n    ', '\n\n    margin: 10px 0;\n']),
    _templateObject2 = _taggedTemplateLiteral(['', ''], ['', '']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: ', '%;\n    display: ', ';\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n'], ['\n    width: ', '%;\n    display: ', ';\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    color: #aaa;\n    display: block;\n    margin-top: 5px;\n'], ['\n    color: #aaa;\n    display: block;\n    margin-top: 5px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    color: #f5222d;\n    margin-top: 5px;\n    display: block;\n'], ['\n    color: #f5222d;\n    margin-top: 5px;\n    display: block;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    box-sizing: border-box;\n    white-space: normal;\n    margin-bottom: 5px;\n    display: inline-block;\n    padding-right: 20px;\n    vertical-align: top;\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n    width: ', '%;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n'], ['\n    box-sizing: border-box;\n    white-space: normal;\n    margin-bottom: 5px;\n    display: inline-block;\n    padding-right: 20px;\n    vertical-align: top;\n    &::before {\n        content: ', ';\n        color: #f5222d;\n        margin-right: 4px;\n    }\n    width: ', '%;\n    @media (max-width: 756px) {\n        width: 100%;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _Text = require('../textComponents/Text');

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getStyle = function getStyle(css) {
    var className = css ? css.match('class="([^"]*)')[1] : null;
    var style = css ? css.match('style="([^"]*)')[1] : '';

    return {
        className: className,
        style: style
    };
};

var StyledItem = _styledComponents2.default.div(_templateObject, function (props) {
    return (0, _styledComponents.css)(_templateObject2, props.cssStyle);
});

var FieldWrapper = _styledComponents2.default.div(_templateObject3, function (_ref) {
    var vertical = _ref.vertical;
    return vertical ? 100 : 50;
}, function (_ref2) {
    var vertical = _ref2.vertical;
    return vertical ? 'block' : 'inline-block';
});

var Specification = _styledComponents2.default.span(_templateObject4);

var Error = _styledComponents2.default.span(_templateObject5);

var Label = _styledComponents2.default.span(_templateObject6, function (_ref3) {
    var required = _ref3.required;
    return required ? '"*"' : null;
}, function (_ref4) {
    var vertical = _ref4.vertical;
    return vertical ? 100 : 50;
});

exports.default = function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
        _inherits(_class, _Component);

        function _class() {
            var _ref5;

            var _temp, _this, _ret;

            _classCallCheck(this, _class);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref5, [this].concat(args))), _this), _this.onChange = function (value) {
                var _this$props = _this.props,
                    type = _this$props.type,
                    _this$props$input = _this$props.input,
                    onChange = _this$props$input.onChange,
                    inputType = _this$props$input.type;


                onChange({ type: type || inputType, value: value });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(_class, [{
            key: 'render',
            value: function render() {
                var _props = this.props,
                    language = _props.language,
                    item = _props.item,
                    meta = _props.meta,
                    _props$input$value = _props.input.value,
                    value = _props$input$value === undefined ? {} : _props$input$value,
                    required = _props.required,
                    vertical = _props.vertical;

                var showErr = meta.error && meta.submitFailed;
                var css = getStyle(item.css);
                var specification = (0, _experiumPlayerHelpersLegacy.getText)(item, language, 'specification');
                var labelText = (0, _experiumPlayerHelpersLegacy.getText)(item, language);

                return _react2.default.createElement(
                    StyledItem,
                    { cssStyle: css.style, className: css.className, error: showErr },
                    _react2.default.createElement(
                        Label,
                        { required: required, vertical: vertical },
                        labelText && _react2.default.createElement(_Text2.default, { text: labelText })
                    ),
                    _react2.default.createElement(
                        FieldWrapper,
                        { vertical: vertical },
                        WrappedComponent && _react2.default.createElement(WrappedComponent, _extends({}, this.props, { onChange: this.onChange, value: value.value })),
                        showErr && _react2.default.createElement(
                            Error,
                            null,
                            _react2.default.createElement(_experiumPlayerHelpersLegacy.FormattedMessage, { id: meta.error })
                        ),
                        specification && _react2.default.createElement(
                            Specification,
                            null,
                            specification
                        )
                    )
                );
            }
        }]);

        return _class;
    }(_react.Component), _class.displayName = 'FieldWrapper', _class.propTypes = {
        item: _propTypes2.default.object,
        required: _propTypes2.default.bool,
        language: _propTypes2.default.string,
        vertical: _propTypes2.default.bool,
        type: _propTypes2.default.string,
        input: _propTypes2.default.object.isRequired,
        meta: _propTypes2.default.object.isRequired
    }, _temp2;
};